<div class="add-vehicle-card" *ngIf="isVisible">
  <div class="card-content">
    <!-- Header Section -->
    <div class="card-header">
      <h3 class="card-title">{{ editMode ? 'Edit Vehicle' : 'Add Vehicle' }}</h3>

      <!-- Form Section -->
      <div class="form-section">
        <div class="form-row">
          <!-- State Field -->
          <div class="form-field">
            <label class="field-label">States<span class="required">*</span></label>
            <div class="select-wrapper p-custom-select">
              <mat-select
                class="form-select"
                [(ngModel)]="selectedState"
                (selectionChange)="onInputChange()"
              >
                <mat-option value="">Select State</mat-option>
                <mat-option *ngFor="let state of states" [value]="state.code">
                  {{ state.name }}
                </mat-option>
              </mat-select>
              <!-- <svg class="select-icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="#717683" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
              </svg> -->
            </div>
          </div>

          <!-- License Plate Field -->
          <div class="form-field">
            <label class="field-label">License Plate Number<span class="required">*</span></label>
            <div class="input-wrapper">
              <input
                type="text"
                class="form-input"
                placeholder="e.g. UFC-37216"
                [(ngModel)]="licensePlate"
                (input)="onInputChange()"
              />
              <button
                class="fetch-btn"
                (click)="onFetchVehicle()"
                [disabled]="!canFetch || isLoading"
              >
                <svg *ngIf="!isLoading" width="20" height="20" viewBox="0 0 20 20" fill="white">
                  <path
                    d="M4.17 6.67L15.83 6.67M15.83 6.67L11.67 2.5M15.83 6.67L11.67 10.83"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div *ngIf="isLoading" class="loading-spinner"></div>
              </button>
            </div>
          </div>
        </div>

        <!-- Help Text -->
        <p class="help-text" *ngIf="!isVehicleFetched && !vehicleData && !isManualEntry">
          {{
            editMode
              ? 'Update the state & license plate number and click the arrow to fetch updated vehicle details.'
              : 'Add the state & license plate number and click the arrow to fetch vehicle details.'
          }}
        </p>

        <!-- CWS-1384: this car carries a live membership, which follows the plate. -->
        <div *ngIf="activeMembershipNotice" class="membership-sync-hint">
          <span>{{ activeMembershipNotice }}</span>
        </div>

        <!-- CWS-1384: imported customer — the vendor holds the plate of record. Informational
             only; the save proceeds either way. -->
        <div *ngIf="vendorPlateSyncNotice" class="vendor-sync-hint">
          <span>{{ vendorPlateSyncNotice }}</span>
        </div>

        <!-- Fetch Error Message (or the manual-entry prompt after a lookup miss) -->
        <div
          *ngIf="errorMessage"
          class="error-message"
          [class.manual-entry-hint]="isManualEntry && errorMessage === manualEntryMessage"
        >
          <span>{{ errorMessage }}</span>
        </div>

        <!-- Manual Vehicle Entry - shown when the lookup found nothing for this plate -->
        <div *ngIf="isManualEntry && !isVehicleFetched && !isLoading" class="manual-vehicle-fields">
          <div class="form-row">
            <div class="form-field">
              <label class="field-label">Year<span class="required">*</span></label>
              <input
                type="text"
                class="form-control"
                inputmode="numeric"
                autocomplete="off"
                maxlength="4"
                placeholder="e.g. 2020"
                [(ngModel)]="manualYear"
                (input)="onManualYearInput()"
                [disabled]="isSaving"
              />
              <div class="field-error" *ngIf="manualYearError">{{ manualYearError }}</div>
            </div>
            <div class="form-field">
              <label class="field-label">Make<span class="required">*</span></label>
              <input
                type="text"
                class="form-control"
                maxlength="50"
                placeholder="e.g. Toyota"
                [(ngModel)]="manualMake"
                (input)="onManualMakeInput()"
                [disabled]="isSaving"
              />
              <div class="field-error" *ngIf="manualMakeError">{{ manualMakeError }}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-field">
              <label class="field-label">Model<span class="required">*</span></label>
              <input
                type="text"
                class="form-control"
                maxlength="50"
                placeholder="e.g. Camry"
                [(ngModel)]="manualModel"
                (input)="onManualModelInput()"
                [disabled]="isSaving"
              />
              <div class="field-error" *ngIf="manualModelError">{{ manualModelError }}</div>
            </div>
          </div>
        </div>
        <div class="details-fetched-text p6" *ngIf="isVehicleFetched && vehicleData">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.91602 1.9486C10.7958 2.45659 11.5277 3.18557 12.0392 4.06335C12.5508 4.94114 12.8241 5.9373 12.8323 6.95321C12.8406 7.96913 12.5833 8.96957 12.086 9.8555C11.5888 10.7414 10.8687 11.4821 9.99724 12.0043C9.12574 12.5264 8.13298 12.8119 7.11724 12.8325C6.1015 12.853 5.098 12.6079 4.20609 12.1215C3.31418 11.635 2.56477 10.9241 2.03207 10.059C1.49937 9.19389 1.20184 8.20468 1.16893 7.18926L1.16602 7.00026L1.16893 6.81126C1.2016 5.80384 1.49475 4.82207 2.01981 3.96168C2.54486 3.10128 3.2839 2.39161 4.16487 1.90186C5.04584 1.41211 6.03868 1.15899 7.0466 1.16718C8.05452 1.17538 9.04312 1.44459 9.91602 1.9486ZM9.16177 5.42118C9.06132 5.32074 8.92768 5.26041 8.78591 5.25149C8.64415 5.24258 8.504 5.2857 8.39177 5.37276L8.33693 5.42118L6.41602 7.34151L5.66177 6.58785L5.60693 6.53943C5.49469 6.45243 5.35457 6.40936 5.21283 6.4183C5.0711 6.42724 4.9375 6.48758 4.83709 6.588C4.73667 6.68842 4.67633 6.82202 4.66739 6.96375C4.65845 7.10548 4.70151 7.2456 4.78852 7.35785L4.83693 7.41268L6.0036 8.57935L6.05843 8.62776C6.16073 8.70713 6.28653 8.75021 6.41602 8.75021C6.5455 8.75021 6.6713 8.70713 6.7736 8.62776L6.82843 8.57935L9.16177 6.24601L9.21018 6.19118C9.29725 6.07894 9.34036 5.9388 9.33145 5.79703C9.32254 5.65527 9.2622 5.52163 9.16177 5.42118Z"
              fill="#079271"
            />
          </svg>
          Details Fetched
        </div>

        <!-- Save Error Message -->

        <!-- Shimmer Loader - Shown during API call -->
        <div *ngIf="isLoading" class="shimmer-container">
          <div class="shimmer-field">
            <div class="shimmer-label"></div>
            <div class="shimmer-input"></div>
          </div>

          <ng-container *ngTemplateOutlet="shimmerRow"></ng-container>
          <ng-container *ngTemplateOutlet="shimmerRow"></ng-container>
        </div>

        <!-- Vehicle Details Section - Only shown when vehicle is fetched -->
        <div *ngIf="isVehicleFetched && vehicleData" class="vehicle-details">
          <div class="form-field">
            <label class="field-label">Vehicle</label>
            <input
              type="text"
              class="form-control"
              disabled
              [value]="vehicleData.year + ' ' + vehicleData.make + ' ' + vehicleData.model"
              placeholder="Vehicle details will appear here"
            />
          </div>

          <div class="form-row">
            <div class="form-field">
              <label class="field-label">Year</label>
              <input
                type="text"
                class="form-control"
                disabled
                [value]="vehicleData.year"
                placeholder="Year"
              />
            </div>
            <div class="form-field">
              <label class="field-label">Make</label>
              <input
                type="text"
                class="form-control"
                disabled
                [value]="vehicleData.make"
                placeholder="Make"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-field">
              <label class="field-label">Model</label>
              <input
                type="text"
                class="form-control"
                disabled
                [value]="vehicleData.model"
                placeholder="Model"
              />
            </div>
            <div class="form-field">
              <label class="field-label">VIN</label>
              <input
                type="text"
                class="form-control"
                disabled
                [value]="vehicleData.vin"
                placeholder="VIN"
              />
            </div>
          </div>
        </div>

        <div *ngIf="saveErrorMessage" class="error-message">
          <span>{{ saveErrorMessage }}</span>
        </div>
      </div>
    </div>

    <!-- Footer Buttons -->
    <div class="card-footer">
      <button class="btn btn-tertiary" (click)="onCancel()">Cancel</button>
      <button class="btn btn-secondary btn-medium" [disabled]="!canSave" (click)="onSave()">
        <span *ngIf="!isSaving">{{ editMode ? 'Save' : 'Save' }}</span>
        <span *ngIf="isSaving">{{ editMode ? 'Updating...' : 'Saving...' }}</span>
      </button>
    </div>
  </div>
</div>

<!-- CWS-2053: the plate is on another customer's car; keep it there or transfer it here. -->
<app-confirm-action-modal
  *ngIf="transferPrompt as prompt"
  [title]="prompt.title"
  [message]="prompt.message"
  [confirmLabel]="prompt.transferLabel"
  [cancelLabel]="prompt.keepLabel"
  testId="vehicle-transfer-dialog"
  (confirm)="onConfirmTransfer()"
  (cancel)="onKeepWithCurrentCustomer()"
></app-confirm-action-modal>

<!-- Shimmer Row Template (reused for loading skeleton rows) -->
<ng-template #shimmerRow>
  <div class="shimmer-row">
    <div class="shimmer-field">
      <div class="shimmer-label"></div>
      <div class="shimmer-input"></div>
    </div>
    <div class="shimmer-field">
      <div class="shimmer-label"></div>
      <div class="shimmer-input"></div>
    </div>
  </div>
</ng-template>
